import qs from 'qs';

export function buildQuery(params?: Record<string, string | number>) {
  return params ? `?${qs.stringify(params)}` : '';
}
